import { ProjectStatusEnumValue } from "@backend/src/schemas/enums";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Dialog from "@/components/common/Dialog";
import { Button } from "@/components/ui/button";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  projectStatus?: string;
  projectSettingsLink: string;
  modalClass?: string;
};

export default function ProjectStatusEditBlockedDialog({
  isOpen,
  onClose,
  projectStatus,
  projectSettingsLink,
  modalClass = "rounded-lg",
}: Props) {
  const { t } = useTranslation();

  const statusColorClass =
    projectStatus === ProjectStatusEnumValue.COMPLETED ||
    projectStatus === ProjectStatusEnumValue.CLOSED
      ? "text-green-600"
      : "text-red-500";

  return (
    <Dialog isOpen={isOpen} onClose={onClose} modalClass={modalClass}>
      <div className="flex flex-col gap-3 p-6 text-center">
        <div className={`text-lg font-bold ${statusColorClass}`}>
          {projectStatus ? t(projectStatus) : ""}
        </div>

        <div className="text-sm text-gray-700 text-center">
          {t("project_status_blocked_dialog_prefix")}{" "}
          <span className="font-semibold">
            {projectStatus ? t(projectStatus) : ""}
          </span>
          . {t("project_status_blocked_dialog_warning")}
        </div>

        <div className="text-center">
          <Link
            to={projectSettingsLink}
            className="text-primary-400 underline"
          >
            {t("project_settings")}
          </Link>
        </div>

        <div className="flex justify-center">
          <Button variant={"primary"} onClick={onClose} className="w-28">
            OK
          </Button>
        </div>
      </div>
    </Dialog>
  );
}

